import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import NavbarButton from "./NavbarButton.tsx";
import {
  // PiHouse,
  // PiHouseFill,
  PiUploadSimple,
  PiUploadSimpleFill,
  PiReceipt,
  PiReceiptFill,
  // PiLightbulb,
  // PiLightbulbFill,
  PiMoney,
  PiMoneyFill,
  PiCurrencyDollar,
  PiCurrencyDollarFill,
  PiPiggyBank,
  PiPiggyBankFill,
  PiGear,
  PiGearFill,
} from "react-icons/pi";
import "./NavbarButtonGroup.css";

interface NavbarButtonGroupProps {
  isCollapsed: boolean;
}

const NavbarButtonGroup: React.FC<NavbarButtonGroupProps> = ({
  isCollapsed,
}) => {
  const location = useLocation();
  const [selectedButton, setSelectedButton] = useState<string | null>(null);

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setSelectedButton("Dashboard");
        break;
      case "/receipt-upload":
        setSelectedButton("Receipt Upload");
        break;
      case "/receipt-library":
        setSelectedButton("Receipt Library");
        break;
      case "/savings":
        setSelectedButton("Savings");
        break;
      case "/learn":
        setSelectedButton("Learn");
        break;
      case "/reimburse":
        setSelectedButton("Reimburse");
        break;
      case "/tax-center":
        setSelectedButton("Tax Center");
        break;
      case "/settings":
        setSelectedButton("Settings");
        break;
      default:
        setSelectedButton(null);
    }
  }, [location.pathname]);

  return (
    <div className={`navbar-button-group ${isCollapsed ? "collapsed" : ""}`}>
      {/* <Link to="/" onClick={() => setSelectedButton('Dashboard')}>
        <NavbarButton
          icon={<PiHouse />}
          filledIcon={<PiHouseFill />}
          text="Dashboard"
          isSelected={selectedButton === 'Dashboard'}
          onClick={() => setSelectedButton('Dashboard')}
        />
      </Link> */}
      <Link to="/savings" onClick={() => setSelectedButton("Savings")}>
        <NavbarButton
          icon={<PiPiggyBank />}
          filledIcon={<PiPiggyBankFill />}
          text="Savings"
          isSelected={selectedButton === "Savings"}
          onClick={() => setSelectedButton("Savings")}
        />
      </Link>
      <Link
        to="/receipt-library"
        onClick={() => setSelectedButton("Receipt Library")}
      >
        <NavbarButton
          icon={<PiReceipt />}
          filledIcon={<PiReceiptFill />}
          text="Receipt Library"
          isSelected={selectedButton === "Receipt Library"}
          onClick={() => setSelectedButton("Receipt Library")}
        />
      </Link>
      <Link
        to="/receipt-upload"
        onClick={() => setSelectedButton("Receipt Upload")}
      >
        <NavbarButton
          icon={<PiUploadSimple />}
          filledIcon={<PiUploadSimpleFill />}
          text="Receipt Upload"
          isSelected={selectedButton === "Receipt Upload"}
          onClick={() => setSelectedButton("Receipt Upload")}
        />
      </Link>
      {/* <Link to="/learn" onClick={() => setSelectedButton('Learn')}>
        <NavbarButton
          icon={<PiLightbulb />}
          filledIcon={<PiLightbulbFill />}
          text="Learn"
          isSelected={selectedButton === 'Learn'}
          onClick={() => setSelectedButton('Learn')}
        />
      </Link> */}
      <Link to="/reimburse" onClick={() => setSelectedButton("Reimburse")}>
        <NavbarButton
          icon={<PiMoney />}
          filledIcon={<PiMoneyFill />}
          text="Reimburse"
          isSelected={selectedButton === "Reimburse"}
          onClick={() => setSelectedButton("Reimburse")}
        />
      </Link>
      <Link to="/tax-center" onClick={() => setSelectedButton('Tax Center')}>
        <NavbarButton
          icon={<PiCurrencyDollar />}
          filledIcon={<PiCurrencyDollarFill />}
          text="Tax Center"
          isSelected={selectedButton === 'Tax Center'}
          onClick={() => setSelectedButton('Tax Center')}
        />
      </Link>
      <Link to="/settings" onClick={() => setSelectedButton("Settings")}>
        <NavbarButton
          icon={<PiGear />}
          filledIcon={<PiGearFill />}
          text="Settings"
          isSelected={selectedButton === "Settings"}
          onClick={() => setSelectedButton("Settings")}
        />
      </Link>
    </div>
  );
};

export default NavbarButtonGroup;
